import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import FlowOvertime from '@/types/table/flowOvertime';
import { MeetingRequestData } from '@/api/generated/meetingRequestController';
import { OvertimeHoursData } from '@/api/generated/overtimeHoursController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface FlowOvertimeData extends FlowOvertime {
  meetingRequest?: MeetingRequestData;
  overtimeHours?: OvertimeHoursData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class FlowOvertimeController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<FlowOvertimeData>>(API_CONTEXT + '/app/flowOvertime/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<FlowOvertimeData>(API_CONTEXT + '/app/flowOvertime/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/flowOvertime/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/flowOvertime/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/flowOvertime/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/delete', params, httpOptions);
  }
    static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }

  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowOvertime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/startOnly/flowOvertime', params, httpOptions);
  }
  static startWithBusinessKeyFlowOvertime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/startWithBusinessKey/flowOvertime', params, httpOptions);
  }
  static startAndTakeUserTaskFlowOvertime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/startAndTakeUserTask/flowOvertime', params, httpOptions);
  }
  static startAndSaveDraftFlowOvertime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/startAndSaveDraft/flowOvertime', params, httpOptions);
  }
  static submitUserTaskFlowOvertime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/submitUserTask/flowOvertime', params, httpOptions);
  }
  static viewTaskBusinessDataFlowOvertime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/flowOvertime/viewTaskBusinessData/flowOvertime', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataFlowOvertime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/flowOvertime/viewHistoricTaskBusinessData/flowOvertime', params, httpOptions);
  }
  static listWorkOrderFlowOvertime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/listWorkOrder/flowOvertime', params, httpOptions);
  }
  static getOvertimeHours(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/flowOvertime/getOvertimeHours', params, httpOptions);
  }
  static getOvertimeHoursMonth(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/flowOvertime/getOvertimeHoursMonth', params, httpOptions);
  }
  static getListByFlowStatus(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<FlowOvertimeData>>(API_CONTEXT + '/app/flowOvertime/getListByFlowStatus', params, httpOptions);
  }
  static updateValidity(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/flowOvertime/updateValidity', params, httpOptions);
  }
}
